import React from 'react';
import { Box, Text, Icons, useTheme } from '@ublend-npm/aulaui-core';

const ComingSoon = () => {
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <Box display="flex" flexDirection="column" width="46rem" pb="4rem">
        <Box position="relative">
          <Icons.AulaLogo
            primaryColor={palette.primary.main}
            secondaryColor={
              palette?.mode === 'dark'
                ? palette.common.white
                : palette.common.black
            }
            fontSize={9}
          />
          <Text
            fontSize="2.125rem"
            fontWeight={500}
            sx={{
              position: 'absolute',
              top: '114px',
              color:
                palette?.mode === 'dark' ? 'rgb(255, 255, 255, 0.7)' : '#0009',
            }}
          >
            Coming soon!
          </Text>
        </Box>
        <Text mt={5} lineHeight={2}>
          We’re crafting a new home experience designed to make learning
          smoother and more personalised.
        </Text>
        <Text> We’re designing a better learning experience for you!</Text>
        <Text mt={3}>
          Stay tuned - something exciting is coming soon! &nbsp;
          <span role="img" aria-label="coming soon">
            🚀
          </span>
        </Text>
      </Box>
    </Box>
  );
};

export default ComingSoon;
